import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsGrupoComercialClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/grupo-comercial');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Comunicado');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/grupo-comercial', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Comunicado');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/grupo-comercial', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as  Comunicado');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/grupo-comercial/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a  Comunicado');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/grupo-comercial', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a  Comunicado');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/grupo-comercial/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a  Comunicado');
    }
  }
}
